import { useSearchStore } from '@/store/SearchStore';

export const ErrorMessage = () => {
  const { error } = useSearchStore();
  if (!error) return null;
  return (
    <div className="my-1 flex flex-col gap-2 rounded-sm border-4 border-red-600 p-4 dark:border-red-400">
      <h2 className="text-xl font-bold">There is a problem</h2>
      <span className="text-red-600 underline underline-offset-2 dark:text-red-400">{error}</span>
    </div>
  );
};
